import request from './request'
import Qs from 'qs'

export default {
  DataAjax (path, data, methods = '') {
    console.log(data)
    if (methods === 'post') {
      return request({
        url: path,
        method: methods,
        data: Qs.stringify(data)
      })
    } else if (methods === 'get') {
      return request({
        url: path,
        method: methods,
        params: data
      })
    } else if (methods === 'post_json') {
      return request({
        url: path,
        method: 'post',
        data: Qs.stringify(data),
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/server.js